import type { ReactNode } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import styles from './ConfirmModal.module.css';

export function ConfirmModal({
  open,
  title,
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'danger',
  secondaryLabel,
  secondaryVariant = 'success',
  onCancel,
  onConfirm,
  onSecondary,
  isPending,
  isSecondaryPending,
  confirmDisabled,
  showClose = false,
}: {
  open: boolean;
  title: string;
  children?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: 'danger' | 'primary' | 'success';
  secondaryLabel?: string;
  secondaryVariant?: 'danger' | 'primary' | 'success';
  onCancel: () => void;
  onConfirm: () => void;
  onSecondary?: () => void;
  isPending?: boolean;
  isSecondaryPending?: boolean;
  confirmDisabled?: boolean;
  showClose?: boolean;
}) {
  const dismiss = isPending || isSecondaryPending ? () => {} : onCancel;
  const busy = !!isPending || !!isSecondaryPending;
  return (
    <Modal open={open} onClose={dismiss} title={title} showClose={showClose}>
      {children ? <div className={styles.body}>{children}</div> : null}
      <div className={styles.actions}>
        <Button type="button" variant="ghost" onClick={onCancel} disabled={busy}>
          {cancelLabel}
        </Button>
        {onSecondary && secondaryLabel ? (
          <Button
            type="button"
            variant={secondaryVariant}
            onClick={onSecondary}
            disabled={busy}
          >
            {isSecondaryPending ? 'Saving…' : secondaryLabel}
          </Button>
        ) : null}
        <Button type="button" variant={confirmVariant} onClick={onConfirm} disabled={busy || confirmDisabled}>
          {isPending ? 'Please wait…' : confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
